import documentsAPI from "@/services/api/document"
import receiptsAPI from "@/services/api/receipts"
import i18n from '@/i18n'

export const ocrExpense = async (file: File, onError: (error: Error) => void) => {
  try {
    if (file.type === 'application/pdf') {
      const result = await documentsAPI.analyzeExpense(file);
      return result;
    } else if (file.type === 'image/jpeg' || file.type === 'image/png') {
      const result = await receiptsAPI.analyzeExpense(file);
      return result;
    } else {
      throw new Error(i18n.t('validation.unsupportedFileType') as string);
    }
  } catch (error) {
    onError(error as Error)
    return null;
  }
}